<!-- Node Link Dialog -->
@if (bulkEditAuthorFacade.selectPages$ | async; as pages) {
  <div class="flex flex-column row-gap-2 w-full h-full"
    >
    <span>{{ pages.length }} {{ "global.slides" | translate }}</span>
    <!-- Content -->
    <div class="flex flex-shrink-1 flex-column overflow-hidden justify-content-start max-h-15rem border-1">
      @if (pages.length > 3) {
        <div class="flex flex-row flex-wrap gap-2 align-items-center w-full cursor-pointer overflow-auto">
          @for (page of pages; track pageTrackBy($index, page)) {
            <div class="flex w-4rem"
              >
              @if ({
                media: appSharedFacade.media$(page.thumbnailMedia) | async
              }; as mediaData) {
                <img
                  class="h-4rem bg-black-alpha-30 white-space-wrap overflow-hidden text-overflow-ellipsis"
                  [src]="mediaControlService.getUrl(mediaData.media, 'thumbnail') || '/assets/images/no-image.png'"
                  [alt]="mediaData.media?.name || 'global.error_loading_image' | translate" />
              }
            </div>
          }
        </div>
      }
      @if (pages.length <= 3) {
        @for (page of pages; track pageTrackBy(j, page); let j = $index) {
          <div class="flex flex-row column-gap-3 align-items-center w-full h-5rem pl-2 cursor-pointer overflow-hidden"
            >
            <div class="flex w-2rem">
              {{ j + 1 }}
            </div>
            <div class="flex w-6rem">
              @if ({
                media: appSharedFacade.media$(page.thumbnailMedia) | async
              }; as mediaData) {
                <img
                  class="h-4rem bg-black-alpha-30 white-space-wrap overflow-hidden text-overflow-ellipsis"
                  [src]="mediaControlService.getUrl(mediaData.media, 'thumbnail') || '/assets/images/no-image.png'"
                  [alt]="mediaData.media?.name || 'global.error_loading_image' | translate" />
              }
            </div>
            <span class="white-space-wrap overflow-hidden text-overflow-ellipsis w-5rem">
              {{ page?.slideId || '-' }}
            </span>
            <span class="white-space-wrap overflow-hidden text-overflow-ellipsis flex-1">
              {{ page.title }}
            </span>
            <span class="white-space-wrap overflow-hidden text-overflow-ellipsis w-8rem">
              @if (page.mediaType) {
                {{ mediaControlService.getMediaTypeLabelByType(page.mediaType) | translate }}
              }
            </span>
            @if ({
              modality: appSharedFacade.modality$(page.modality) | async
            }; as modalityData) {
              <span
                class="white-space-wrap overflow-hidden text-overflow-ellipsis w-13rem">
                {{ modalityData?.modality?.name || '-' }}
              </span>
            }
            <span class="white-space-wrap overflow-hidden text-overflow-ellipsis w-5rem">
              {{ page.status | translate }}
            </span>
          </div>
        }
      }
    </div>
    <span>{{ nodeIds.length }} {{ "global.pages_linking_choosen" | translate }}</span>
    <div class="flex flex-1 overflow-auto">
      <medsurf-design-content-template-node-tree class="w-full">
        <!-- No Data Template -->
        <ng-template #no_data_template>
          <div class="flex flex-grow-1 flex-shrink-1 flex-column row-gap-1 drag-node">
            <div class="flex flex-grow-1 flex-row column-gap-1 align-items-center p-1 pl-2 h-row border-round hover:surface-hover cursor-pointer">
              <div class="flex flex-grow-1 p-2 w-0">
                <span class="white-space-nowrap overflow-hidden text-overflow-ellipsis">
                  {{ 'global.no_data' | translate }}
                </span>
              </div>
            </div>
          </div>
        </ng-template>
        <!-- Node Template -->
        <ng-template #override_node_template
          let-templateNodeTree="templateNodeTree"
          let-typedNodeExpanded="typedNodeExpanded"
          let-typedRouteElements="typedRouteElements"
          let-node="node"
          let-page="page">
          @if (typedRouteElements[node.id]; as routeElement) {
            <div class="flex flex-grow-1 flex-shrink-1 flex-column row-gap-1 drag-node"
              >
              <div class="flex flex-grow-1 flex-row column-gap-1 align-items-center p-1 pl-2 h-row border-round hover:surface-hover cursor-pointer h-3rem"
                [class.bg-white-alpha-10]="(nodeSharedFacade.currentSelectedRouteElement$ | async) === routeElement">
                @if (routeElement.depth === 3) {
                  <div
                    class="flex w-3rem">
                    <medsurf-design-input-checkbox [formField]="false"
                      [class]="'table-header-switch'"
                      [model]="isInArray(routeElement)"
                      [name]="'node_select_all_' + node.id"
                    (valueChange)="onSwitchChange(routeElement, $event)"></medsurf-design-input-checkbox>
                  </div>
                }
                @if (routeElement.depth < 3) {
                  <div
                    class="flex w-2rem">
                    <button medsurf-design-input-button [id]="'node_toggle_' + node.id"
                      [title]="(!typedNodeExpanded[node.id] ? 'global.node_toggle_open' : 'global.node_toggle_close') | translate"
                      [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_SMALL_TEXT"
                      [iconClass]="(!typedNodeExpanded[node.id] || node.children.length === 0 ? FlatModels.ButtonDesignModels.ButtonDefaultIcons.RIGHT : FlatModels.ButtonDesignModels.ButtonDefaultIcons.DOWN)"
                      [disabled]="node.children.length === 0"
                    (click)="templateNodeTree.onNodeExpand(node)"></button>
                  </div>
                }
                <div class="flex justify-content-center w-2rem">
                  @if (page.type === FlatModels.PageEntityModels.PageType.enum.Slide && (slideAuthorFacade.media$(page.thumbnailMedia) | async); as media) {
                    <img class="max-w-2rem"
                      [src]="mediaControlService.getUrl(media, 'thumbnail') || '/assets/images/no-image.png'"
                      [alt]="media?.name || 'global.error_loading_image' | translate" />
                  }
                  @if (page.type !== FlatModels.PageEntityModels.PageType.enum.Slide) {
                    <i
                      [style.color]="FlatModels.ColorConfigModels.ThemeColorHexValue[page.themeColor] || page.themeColor"
                    class="{{ FlatModels.PageEntityModels.PageTypeIcon[page.type] }} {{ page.themeColor?.length > 0 ? FlatModels.ButtonDesignModels.ButtonSolidStyle : '' }}"></i>
                  }
                </div>
                <div class="flex flex-grow-1 w-0">
                  <span class="white-space-wrap overflow-hidden text-overflow-ellipsis">
                    {{ page.title }}
                  </span>
                </div>
              </div>
              @if (routeElement.depth < 3 && page.type !== FlatModels.PageEntityModels.PageType.enum.Slide && page.type !== FlatModels.PageEntityModels.PageType.enum.Training) {
                @if (nodeSharedFacade.nodeByIds$(node.children) | async | sortBy_shared:'asc':'position'; as childNodes) {
                  <div [hidden]="!typedNodeExpanded[node.id]"
                    class="flex flex-1 flex-column row-gap-1 ml-4">
                    @if (node.children.length === 0) {
                      <ng-container *ngTemplateOutlet="no_data_template"></ng-container>
                    }
                    @if (childNodes.length === 0) {
                      @for (i of node.children; track i) {
                        <p-skeleton height="3rem" class="cursor-wait"></p-skeleton>
                      }
                    }
                    @if (childNodes.length > 0) {
                      <div>
                        <ng-container *ngFor="let childNode of childNodes; trackBy:templateNodeTree.trackByNode">
                        <!-- @for (childNode of childNodes; track templateNodeTree.trackByNode($index, childNode)) { -->
                          <ng-container *ngTemplateOutlet="override_node_template;context:{
                                        templateNodeTree,
                                        typedNodeExpanded,
                                        typedRouteElements,
                                        node: childNode,
                                        page: slideAuthorFacade.page$(childNode.page) | async}">
                          </ng-container>
                        </ng-container>
                      </div>
                    }
                  </div>
                }
              }
            </div>
          }
        </ng-template>
        <!-- Menu Template -->
        <ng-template #override_menu_template
          let-templateNodeTree="templateNodeTree"
          let-typedNodeExpanded="typedNodeExpanded"
          let-typedRouteElements="typedRouteElements"
          let-elearnings="elearnings">
          <div class="flex flex-column row-gap-1">
            <ng-container *ngFor="let elearning of elearnings; trackBy:templateNodeTree.trackByNode">
            <!-- @for (elearning of elearnings; track templateNodeTree.trackByNode($index, elearning)) { -->
              <ng-container *ngTemplateOutlet="override_node_template,context:{
                            templateNodeTree,
                            typedNodeExpanded,
                            typedRouteElements,
                            node: elearning,
                            page: slideAuthorFacade.page$(elearning.page) | async}">
              </ng-container>
            </ng-container>
          </div>
        </ng-template>
      </medsurf-design-content-template-node-tree>
    </div>
    <p-footer>
      <div class="flex flex-row justify-content-end align-items-center column-gap-2">
        <button medsurf-design-input-button [id]="'cancel'"
          [label]="'global.cancel' | translate"
          [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.PRIMARY"
        (click)="dynamicDialogRef.close({result: false})"></button>
        @if ({
          nodes: (nodeSharedFacade.nodeByIds$(this.nodeIds) | async) || []
        }; as nodeData) {
          <button medsurf-design-input-button
            [disabled]="nodeData.nodes.length === 0"
            [id]="'action'"
            [label]="'global.pages_linking' | translate"
          (click)="nodeData.nodes.length > 0 && dynamicDialogRef.close({result: true, nodes: nodeData.nodes })"></button>
        }
      </div>
    </p-footer>
  </div>
}
